// utils/helpers/fetchWithUnauthorized.ts

export function handleUnauthorized(response: Response): Response {
  if (response.status === 401 || response.status === 403) {

    window.location.href = '/unauthorized';
  }
  return response;
}

export async function fetchWithUnauthorized(
  request: RequestInfo,
): Promise<Response> {
  const response = await fetch(request);
  return handleUnauthorized(response);
}

export const fetchJSON = async <T = any>(request: RequestInfo): Promise<T> => {
  const res = await fetchWithUnauthorized(request);
  return res.json();
};
